"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var CustomNoResults = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", { className: "ns-font-family", style: { color: "var(--info-color)", padding: "10px", marginLeft: "15px" } }, t("No results found"))));
};
exports.default = CustomNoResults;
